import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaUserTie,
  FaSearch,
  FaSignInAlt,
  FaSignOutAlt,
  FaUserPlus,
  FaUser,
  FaCommentDots,
  FaList,
  FaQrcode
} from "react-icons/fa"; // Import icons
import AuthContext from "../AuthContext";
import logo from "../images/logo.png";

const Navbar = () => {
  const { isLoggedIn, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleMenuToggle = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "";
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="bg-gray-800 sticky top-0 z-50">
      <div className="  mx-auto flex justify-between items-center ">
        {/* Logo or title */}
        <div>
          <Link
            to="/"
            className="flex items-center   md:h-20 md:w-20 text-white text-lg font-bold"
          >
            <img
              src={logo}
              alt="logo"
              className="h-12 w-12 md:h-16 md:w-16 inline-block mr-2"
            />
            <span className="  md:inline">FoodOrderoo</span>
          </Link>
        </div>

        {/* Menu Button for Mobile */}
        <div className="lg:hidden mr-3">
          <button
            onClick={handleMenuToggle}
            className="text-white focus:outline-none"
            id="menu-button"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>

        {/* Navbar Links - Visible on larger screens, hidden on small screens */}
        <div className="hidden lg:flex lg:space-x-4 marker:flex items-center gap-2">
        {isLoggedIn && (
          <Link to="/dashboard">
            <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded flex items-center gap-2">
            <FaList size={20} />
            Dashboard
            </button>
          </Link>
          )}

          <Link to="/feedback">
            <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center gap-2">
              <FaCommentDots size={20} />
              Feedback
            </button>
          </Link>
         

          {isLoggedIn ? (
            <div className="relative mt-1">
              <button
                onClick={toggleDropdown}
                className="bg-gray-500 text-orange-400 font-bold py-2 px-4  rounded-full w-12 h-12 flex items-center justify-center"
              >
                <FaUser  size={20} /> {/* Adjust the size property to make the icon bigger */}
              </button>
              {dropdownVisible && (
                <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-50">
                  {/* <Link
                    to="/profile"
                    onClick={handleMenuToggle}
                    className="block font-bold px-4 py-2 text-gray-600 hover:bg-gray-200"
                  >
                    Profile
                  </Link> */}

      <Link
                    to="/QrCode"
                    onClick={handleMenuToggle}
                    className="block font-bold px-4 py-2 text-gray-600 hover:bg-gray-200"
                  >
                    Download Qr Codes
                  </Link> 
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 font-bold  text-gray-600 hover:bg-gray-200"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <Link to="/register">
                <button className="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded flex items-center gap-2 ml-2">
                  <FaUserPlus size={20} />
                  Register
                </button>
              </Link>
              <Link to="/login">
                <button className="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded flex items-center gap-2">
                  <FaSignInAlt size={20} />
                  Login
                </button>
              </Link>
            </>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden mr-2">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          {isLoggedIn && (
          <Link to="/dashboard">
            <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded w-full flex items-center gap-2 mt-1">
            <FaList size={20} />
            Dashboard
            </button>
          </Link>
          )}
            

            

            {/* <Link to="/feedback" onClick={handleMenuToggle}>
              <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full flex items-center gap-2 mt-1">
                <FaCommentDots size={20} />
                Feedback
              </button>
            </Link> */}

            {isLoggedIn ? (
              <>
                {/* <Link to="/profile" onClick={handleMenuToggle}>
                  <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2  px-4 rounded w-full flex items-center gap-2 mt-1">
                    <FaUserTie size={20} />
                    Profile
                  </button>
                </Link> */}
                <Link to="/QrCode" onClick={handleMenuToggle}>
                  <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2  px-4 rounded w-full flex items-center gap-2 mt-1">
                    <FaQrcode size={20} />
                    Download QR Codes
                  </button>
                </Link>
                <button
                  onClick={handleLogout}
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded w-full flex items-center gap-2 mt-1"
                >
                  <FaSignOutAlt size={20} />
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/register" onClick={handleMenuToggle}>
                  <button className="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded w-full flex items-center gap-2 mt-1">
                    <FaUserPlus size={20} />
                    Register
                  </button>
                </Link>
                <Link to="/login" onClick={handleMenuToggle}>
                  <button className="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded w-full flex items-center gap-2 mt-1">
                    <FaSignInAlt size={20} />
                    Login
                  </button>
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
